<template>
    <Image
        :alt="alt ?? data.alt"
        :fit="fit"
        :loading="isEager ? 'eager' : 'lazy'"
        v-bind="getImageProps(data)"
        :sizes="sizes"
    />
</template>

<script lang="ts" setup>
import type { CmsImageSizesFragment } from '@/graphql/api'

import Image from '@/components/Image.vue'
import { getImageProps, type ImageSizes } from '@/components/getImageProps.ts'

defineProps<{
    data: CmsImageSizesFragment
    alt?: string
    fit?: 'contain' | 'cover' | undefined
    isEager?: boolean
    sizes?: ImageSizes
}>()
</script>
